import { useSelector } from 'react-redux';
import userTypeDuck from '../ducks/user-duck';

const useUserType = () => {
  const userType = useSelector(userTypeDuck.selectors.userType);
  const upperCaseUserType = userType && userType.toUpperCase();

  const isReceiver = upperCaseUserType === 'RECEIVER';
  const isSender = upperCaseUserType === 'SENDER';

  return { isReceiver, isSender };
};

export default useUserType;
